module.exports = __webpack_public_path__ + "img/89.bf38cdee.jpg";